/**
 * Prototype list
 */

function initPrototypes() {
  String.prototype.format = function() {
    let i = 0;
    return this.replace(/{}/g, () => (typeof arguments[i] != "undefined" ? arguments[i++] : ""));
  };
}

export { initPrototypes };
